import React from 'react';

const RootLayout = React.lazy(
  async () => await import('@/pages/Panel/RootLayout/RootLayout'),
);
const DetailLayout = React.lazy(
  async () => await import('@/pages/Panel/DetailLayout'),
);
const NotFound = React.lazy(async () => await import('@/pages/Panel/NotFond'));
const HomePage = React.lazy(async () => await import('@/pages/Panel/Home'));
const AccessGroupLayout = React.lazy(
  async () => await import('@/pages/Panel/AccessGroup/AccessGroupLayout'),
);
const AccessGroupList = React.lazy(
  async () => await import('@/pages/Panel/AccessGroup/AccessGroupList'),
);
const AccessGroupAdd = React.lazy(
  async () => await import('@/pages/Panel/AccessGroup/AccessGroupAdd'),
);
const AccessGroupAttachAccess = React.lazy(
  async () => await import('@/pages/Panel/AccessGroup/AccessGroupAttachAccess'),
);

const AccessGroupGeneralInfo = React.lazy(
  async () => await import('@/pages/Panel/AccessGroup/AccessGroupGeneralInfo'),
);
const AccessGroupGeneralInfoEdit = React.lazy(
  async () =>
    await import('@/pages/Panel/AccessGroup/AccessGroupGeneralInfoEdit'),
);
const AccessGroupAccess = React.lazy(
  async () => await import('@/pages/Panel/AccessGroup/AccessGroupAccess'),
);
const AccessGroupAccessEdit = React.lazy(
  async () => await import('@/pages/Panel/AccessGroup/AccessGroupAccessEdit'),
);
const RolesAccessLayout = React.lazy(
  async () => await import('@/pages/Panel/RolesAccess/RolesAccessLayout'),
);
const RolesAccessList = React.lazy(
  async () => await import('@/pages/Panel/RolesAccess/RolesAccessList'),
);
const RolesAccessAdd = React.lazy(
  async () => await import('@/pages/Panel/RolesAccess/RolesAccessAdd'),
);
const AttachAction = React.lazy(
  async () => await import('@/pages/Panel/RolesAccess/RolesAccessAttachAction'),
);
const RolesAccessActionEdit = React.lazy(
  async () => await import('@/pages/Panel/RolesAccess/RolesAccessActionEdit'),
);
const RolesAccessActionsAddActions = React.lazy(
  async () =>
    await import('@/pages/Panel/RolesAccess/RolesAccessActionsAddActions'),
);
const RolesAccessGeneralInfoEdit = React.lazy(
  async () =>
    await import('@/pages/Panel/RolesAccess/RolesAccessGeneralInfoEdit'),
);
const RolesAccessGeneralInfo = React.lazy(
  async () => await import('@/pages/Panel/RolesAccess/RolesAccessGeneralInfo'),
);
const RolesAccessAction = React.lazy(
  async () => await import('@/pages/Panel/RolesAccess/RolesAccessAction'),
);
const RolesAccessUsers = React.lazy(
  async () => await import('@/pages/Panel/RolesAccess/RolesAccessUsers'),
);
const ActionsLayout = React.lazy(
  async () => await import('@/pages/Panel/Actions/ActionsLayout'),
);
const ActionsList = React.lazy(
  async () => await import('@/pages/Panel/Actions/ActionsList'),
);
const ActionGeneralInfo = React.lazy(
  async () => await import('@/pages/Panel/Actions/ActionGeneralInfo'),
);

const RolesLayout = React.lazy(
  async () => await import('@/pages/Panel/Roles/RolesLayout'),
);
const RolesList = React.lazy(
  async () => await import('@/pages/Panel/Roles/RolesList'),
);
const RoleAdd = React.lazy(async () => await import('@/pages/Panel/Roles/Add'));
const RolesEdit = React.lazy(
  async () => await import('@/pages/Panel/Roles/Edit'),
);
const RolesGeneralInfo = React.lazy(
  async () => await import('@/pages/Panel/Roles/RolesGeneralInfo'),
);
const UsersLayout = React.lazy(
  async () => await import('@/pages/Panel/Users/UsersLayout'),
);
const UserManagementList = React.lazy(
  async () => await import('@/pages/Panel/Users/UserManagementList'),
);
const UserAdd = React.lazy(
  async () => await import('@/pages/Panel/Users/UserAdd'),
);
const UserEdit = React.lazy(
  async () => await import('@/pages/Panel/Users/UserEdit'),
);
const UserInfo = React.lazy(
  async () => await import('@/pages/Panel/Users/UserInfo'),
);
const UserAccountActions = React.lazy(
  async () => await import('@/pages/Panel/Users/UserAccountActions'),
);
const UsersNumbers = React.lazy(
  async () => await import('@/pages/Panel/Users/UsersNumbers'),
);
const UsersSMS = React.lazy(
  async () => await import('@/pages/Panel/Users/UsersSMS'),
);
const UserAccess = React.lazy(
  async () => await import('@/pages/Panel/Users/UserAccess'),
);
const UsersPackages = React.lazy(
  async () => await import('@/pages/Panel/Users/UsersPackages'),
);
const UsersUsers = React.lazy(
  async () => await import('@/pages/Panel/Users/UsersUsers'),
);
const UserTariff = React.lazy(
  async () => await import('@/pages/Panel/Users/UserTariff'),
);
const UserTariffEdit = React.lazy(
  async () => await import('@/pages/Panel/Users/UserTariffEdit'),
);
const Userpayments = React.lazy(
  async () => await import('@/pages/Panel/Users/Userpayments'),
);
const UserTransactions = React.lazy(
  async () => await import('@/pages/Panel/Users/UserTransactions'),
);
const UserAccountRecharge = React.lazy(
  async () => await import('@/pages/Panel/Users/UserAccountRecharge'),
);
const NumbersLayout = React.lazy(
  async () => await import('@/pages/Panel/Numbers/NumbersLayout'),
);
const NumbersManegmentList = React.lazy(
  async () => await import('@/pages/Panel/Numbers/NumbersManegmentList'),
);
const NumbersAdd = React.lazy(
  async () => await import('@/pages/Panel/Numbers/NumbersAdd'),
);
const NumbersEdit = React.lazy(
  async () => await import('@/pages/Panel/Numbers/NumbersEdit'),
);
const NumbersGeneralInfo = React.lazy(
  async () => await import('@/pages/Panel/Numbers/NumbersGeneralInfo'),
);
const NumberTransactions = React.lazy(
  async () => await import('@/pages/Panel/Numbers/NumberTransactions'),
);
const PackagesLayout = React.lazy(
  async () => await import('@/pages/Panel/Packages/PackagesLayout'),
);
const PackagesList = React.lazy(
  async () => await import('@/pages/Panel/Packages/PackagesList'),
);
const PackagesAdd = React.lazy(
  async () => await import('@/pages/Panel/Packages/PackagesAdd'),
);
const PackagesGeneralInfoEdit = React.lazy(
  async () => await import('@/pages/Panel/Packages/PackagesGeneralInfoEdit'),
);
const PackagesAccessLevel = React.lazy(
  async () => await import('@/pages/Panel/Packages/PackagesAccessLevel'),
);
const PackagesActiveUsers = React.lazy(
  async () => await import('@/pages/Panel/Packages/PackagesActiveUsers'),
);
const PackagesGeneralInfo = React.lazy(
  async () => await import('@/pages/Panel/Packages/PackagesGeneralInfo'),
);
const PackagesNumbers = React.lazy(
  async () => await import('@/pages/Panel/Packages/PackagesNumbers'),
);
const PackagesNumbersAdd = React.lazy(
  async () => await import('@/pages/Panel/Packages/PackagesNumbersAdd'),
);
const PackagesPayments = React.lazy(
  async () => await import('@/pages/Panel/Packages/PackagesPayments'),
);
const PackagesTrariff = React.lazy(
  async () => await import('@/pages/Panel/Packages/PackagesTrariff'),
);
const PackagesTrariffAdd = React.lazy(
  async () => await import('@/pages/Panel/Packages/PackagesTrariffAdd'),
);
const PackagesTrariffEdit = React.lazy(
  async () => await import('@/pages/Panel/Packages/PackagesTrariffEdit'),
);
const OperatorsLayout = React.lazy(
  async () => await import('@/pages/Panel/Operators/OperatorsLayout'),
);
const OperatorsList = React.lazy(
  async () => await import('@/pages/Panel/Operators/OperatorsList'),
);
const OperatorsAdd = React.lazy(
  async () => await import('@/pages/Panel/Operators/OperatorsAdd'),
);
const OperatorsEdit = React.lazy(
  async () => await import('@/pages/Panel/Operators/OperatorsEdit'),
);
const OperatorsGeneralInfo = React.lazy(
  async () => await import('@/pages/Panel/Operators/OperatorsGeneralInfo'),
);
const TransactionsLayout = React.lazy(
  async () => await import('@/pages/Panel/Transactions/TransactionsLayout'),
);
const TransactionsList = React.lazy(
  async () => await import('@/pages/Panel/Transactions/TransactionsList'),
);
const TransactionsGeneralInfo = React.lazy(
  async () =>
    await import('@/pages/Panel/Transactions/TransactionsGeneralInfo'),
);
const TransactionsShares = React.lazy(
  async () => await import('@/pages/Panel/Transactions/TransactionsShares'),
);
const TransactionsTransactionsHistory = React.lazy(
  async () =>
    await import('@/pages/Panel/Transactions/TransactionsTransactionsHistory'),
);
const TransactionsViewUser = React.lazy(
  async () => await import('@/pages/Panel/Transactions/TransactionsViewUser'),
);
const PaymentsLayout = React.lazy(
  async () => await import('@/pages/Panel/Payments/PaymentsLayout'),
);
const PaymentsList = React.lazy(
  async () => await import('@/pages/Panel/Payments/PaymentsList'),
);
const PaymentsAdd = React.lazy(
  async () => await import('@/pages/Panel/Payments/PaymentsAdd'),
);
const PaymentsGeneralInfo = React.lazy(
  async () => await import('@/pages/Panel/Payments/PaymentsGeneralInfo'),
);
const PaymentsRelatedPayments = React.lazy(
  async () => await import('@/pages/Panel/Payments/PaymentsRelatedPayments'),
);
const PaymentsTransaction = React.lazy(
  async () => await import('@/pages/Panel/Payments/PaymentsTransaction'),
);
const PaymentsViewUser = React.lazy(
  async () => await import('@/pages/Panel/Payments/PaymentsViewUser'),
);
const ChargesLayout = React.lazy(
  async () => await import('@/pages/Panel/Charges/ChargesLayout'),
);
const ChargesList = React.lazy(
  async () => await import('@/pages/Panel/Charges/ChargesList'),
);
const OrdersLayout = React.lazy(
  async () => await import('@/pages/Panel/Orders/OrdersLayout'),
);
const OrdersList = React.lazy(
  async () => await import('@/pages/Panel/Orders/OrdersList'),
);
const OrdersGeneralInfo = React.lazy(
  async () => await import('@/pages/Panel/Orders/OrdersGeneralInfo'),
);
const OrdersSendStatistics = React.lazy(
  async () => await import('@/pages/Panel/Orders/OrdersSendStatistics'),
);
const OrdersReceivers = React.lazy(
  async () => await import('@/pages/Panel/Orders/OrdersReceivers'),
);
const OrdersPayments = React.lazy(
  async () => await import('@/pages/Panel/Orders/OrdersPayments'),
);
const SMSLayout = React.lazy(
  async () => await import('@/pages/Panel/SMS/SMSLayout'),
);
const SMSList = React.lazy(
  async () => await import('@/pages/Panel/SMS/SMSList'),
);

const SMSGeneralInfo = React.lazy(
  async () => await import('@/pages/Panel/SMS/SMSGeneralInfo'),
);
const SendReport = React.lazy(
  async () => await import('@/pages/Panel/SMS/SendReport'),
);
const SMSSendLayout = React.lazy(
  async () => await import('@/pages/Panel/SendSMS/SendSMSLayout'),
);
const SMSSendForm = React.lazy(
  async () => await import('@/pages/Panel/SendSMS/SendSMSForm'),
);

export {
  RootLayout,
  DetailLayout,
  HomePage,
  NotFound,
  AccessGroupLayout,
  AccessGroupList,
  AccessGroupAdd,
  AccessGroupAttachAccess,
  AccessGroupGeneralInfo,
  AccessGroupGeneralInfoEdit,
  AccessGroupAccess,
  AccessGroupAccessEdit,
  RolesAccessLayout,
  RolesAccessList,
  RolesAccessAdd,
  AttachAction,
  RolesAccessGeneralInfoEdit,
  RolesAccessActionEdit,
  RolesAccessActionsAddActions,
  RolesAccessGeneralInfo,
  RolesAccessAction,
  RolesAccessUsers,
  ActionsLayout,
  ActionsList,
  ActionGeneralInfo,
  RolesLayout,
  RolesList,
  RoleAdd,
  RolesEdit,
  RolesGeneralInfo,
  UsersLayout,
  UserManagementList,
  UserAdd,
  UserEdit,
  UserInfo,
  UserAccountActions,
  UsersNumbers,
  UsersSMS,
  UserAccess,
  UsersPackages,
  UsersUsers,
  UserTariff,
  UserTariffEdit,
  Userpayments,
  UserTransactions,
  UserAccountRecharge,
  NumbersLayout,
  NumbersManegmentList,
  NumbersAdd,
  NumbersEdit,
  NumbersGeneralInfo,
  NumberTransactions,
  PackagesLayout,
  PackagesList,
  PackagesAdd,
  PackagesGeneralInfoEdit,
  PackagesAccessLevel,
  PackagesActiveUsers,
  PackagesGeneralInfo,
  PackagesNumbers,
  PackagesNumbersAdd,
  PackagesPayments,
  PackagesTrariff,
  PackagesTrariffAdd,
  PackagesTrariffEdit,
  OperatorsLayout,
  OperatorsList,
  OperatorsAdd,
  OperatorsEdit,
  OperatorsGeneralInfo,
  TransactionsLayout,
  TransactionsList,
  TransactionsGeneralInfo,
  TransactionsShares,
  TransactionsTransactionsHistory,
  TransactionsViewUser,
  PaymentsLayout,
  PaymentsList,
  PaymentsAdd,
  PaymentsGeneralInfo,
  PaymentsRelatedPayments,
  PaymentsTransaction,
  PaymentsViewUser,
  ChargesLayout,
  ChargesList,
  OrdersLayout,
  OrdersList,
  OrdersGeneralInfo,
  OrdersSendStatistics,
  OrdersReceivers,
  OrdersPayments,
  SMSLayout,
  SMSList,
  SMSGeneralInfo,
  SendReport,
  SMSSendLayout,
  SMSSendForm,
};
